
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies",
      function () {
        return require("private-next-pages/companies/index.tsx");
      }
    ]);
  